const bcBoundingBox = {
  minLongitude: -139.06,
  maxLongitude: -114.03,
  minLatitude: 48.3,
  maxLatitude: 60.0,
};

export const validateBcCoordinates = (longitude, latitude) => {
  //https://gis.stackexchange.com/questions/154740/lat-and-long-extents-of-canadian-provinces

  if ((longitude === undefined || longitude === null) && (latitude === undefined || latitude === null)) return true;

  if (
    longitude >= bcBoundingBox.minLongitude &&
    longitude <= bcBoundingBox.maxLongitude &&
    latitude >= bcBoundingBox.minLatitude &&
    latitude <= bcBoundingBox.maxLatitude
  ) {
    return true;
  }

  return false;
};

export const validateBcLongitude = (longitude) => {
  if (longitude === undefined || longitude === null) return true;

  if (longitude >= bcBoundingBox.minLongitude && longitude <= bcBoundingBox.maxLongitude) {
    return true;
  }

  return false;
};

export const validateBcLatitude = (latitude) => {
  if (latitude === undefined || latitude === null) return true;

  if (latitude >= bcBoundingBox.minLatitude && latitude <= bcBoundingBox.maxLatitude) {
    return true;
  }

  return false;
};
